import React from 'react';
import {Button, CircularProgress} from 'material-ui';

class PageBuilderSubmit extends React.Component {
    render() {
        const {
            isDirty,
            classes,
            saveButtonLabel,
            buttonClassName,
            loading,
            onSubmit,
            onDiscard,
            onSetPreview,
            onPageClone,
            hasMissingTranslations,
        } = this.props;

        return (
            <div style={{textAlign: 'center'}}>
                {isDirty && (
                    <Button
                        variant="raised"
                        color="primary"
                        disabled={loading}
                        onClick={() => {
                            onSubmit();
                        }}
                        className={buttonClassName}
                    >
                        {saveButtonLabel}
                    </Button>
                )}

                {loading && (
                    <CircularProgress
                        size={24}
                        className={classes.progressIcon}
                    />
                )}

                {isDirty && (
                    <Button
                        variant="raised"
                        color="primary"
                        disabled={loading}
                        onClick={() => {
                            onSetPreview();
                        }}
                        className={classes.buttonPreview}
                    >
                        Preview
                    </Button>
                )}

                {hasMissingTranslations && (
                    <Button
                        variant="raised"
                        onClick={onPageClone}
                        disabled={loading}
                        className={classes.cloneButton}
                    >
                        Add Translation
                    </Button>
                )}

                {isDirty && (
                    <Button
                        variant="raised"
                        onClick={onDiscard}
                        disabled={loading}
                        className={classes.discardButton}
                    >
                        Discard
                    </Button>
                )}
            </div>
        );
    }
}

export default PageBuilderSubmit;



// WEBPACK FOOTER //
// ./src/containers/builder/form/builder_submit.js